import Swiper from 'https://cdn.jsdelivr.net/npm/swiper@12/swiper-bundle.min.mjs'

// Testimonials slider
window.swiper = new Swiper('.carousel', {
  updateOnWindowResize: true,
  centeredSlides: false,
  slidesPerView: 3,
  spaceBetween: 15,
  speed: 2000,
  loop: true,
  breakpoints: {
    320: {
      slidesPerView: 1.4
    },
    760: {
      slidesPerView: 1.4
    },
    992: {
      slidesPerView: 3.4
    }
  },
  autoplay: {
    delay: 7000,
    disableOnInteraction: false,
  },
  keyboard: {
    enabled: true,
    onlyInViewport: false,
  },
  navigation: {
    prevEl: '.swiper-button-prev',
    nextEl: '.swiper-button-next'
  },
  grabCursor: true
});

// Mobile only slider
// Store swiper instances per container
const swiperInstances = new WeakMap();

function initSwiper() {
  const containers = document.querySelectorAll('.mobile-carousel, .mobile-only-carousel, .mobile-only-slider');
  if (!containers.length) return;

  containers.forEach(container => {
    const wrapper = container.firstElementChild;
    if (!wrapper) {
      console.warn('❌ No wrapper found (no child element)', container);
      return;
    }

    const existingInstance = swiperInstances.get(container);

    // ✅ Enable Swiper only on mobile
    if (window.innerWidth <= 768 && !existingInstance) {
      // Add Swiper classes dynamically
      container.classList.add('swiper');
      wrapper.classList.add('swiper-wrapper');
      [...wrapper.children].forEach(child => child.classList.add('swiper-slide'));

      const navWrapper = document.createElement('div');
      navWrapper.className = 'swiper-nav';
      container.appendChild(navWrapper);

      const prevBtn = document.createElement('div');
      prevBtn.className = 'swiper-button-prev';
      navWrapper.appendChild(prevBtn);

      const nextBtn = document.createElement('div');
      nextBtn.className = 'swiper-button-next';
      navWrapper.appendChild(nextBtn);

      const swiper = new Swiper(container, {
        centeredSlides: true,
        slidesPerView: 1.4,
        spaceBetween: 10,
        speed: 2000,
        loop: true,
        // autoplay: {
        //   delay: 5000,
        //   disableOnInteraction: false,
        // },
        keyboard: {
          enabled: true,
          onlyInViewport: false,
        },
        navigation: {
          prevEl: prevBtn,
          nextEl: nextBtn,
        },
        grabCursor: true,
      });

      swiperInstances.set(container, swiper);
      console.log('✅ Swiper initialized:', container);
    }
    // ❌ Destroy Swiper on desktop
    else if (window.innerWidth > 768 && existingInstance) {
      existingInstance.destroy(true, true);
      swiperInstances.delete(container);
      container.classList.remove('swiper');
      wrapper.classList.remove('swiper-wrapper');
      [...wrapper.children].forEach(child => child.classList.remove('swiper-slide'));

      // ✅ Remove navigation buttons
      const navWrapper = container.querySelector('.swiper-nav');
      if (navWrapper) navWrapper.remove();
      const prevBtn = container.querySelector('.swiper-button-prev');
      const nextBtn = container.querySelector('.swiper-button-next');
      if (prevBtn) prevBtn.remove();
      if (nextBtn) nextBtn.remove();

      console.log('❌ Swiper destroyed:', container);
    }
  });
}

// Add listeners (with a debounce for performance)
let resizeTimeout;
window.addEventListener('load', initSwiper);
window.addEventListener('resize', () => {
  clearTimeout(resizeTimeout);
  resizeTimeout = setTimeout(initSwiper, 200);
});